var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.config),expression:"config"}],attrs:{"name":_vm.name,"type":_vm.type,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"focus":function($event){_vm.$emit('focus')},"blur":function($event){_vm.$emit('blur')},"input":_vm.onInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cac996e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ext/the-mask/the-mask.vue
// module id = 657
// module chunks = 1